import { isEmpty } from 'lodash';
import { Radio as AntdRadio } from 'antd';

import Checkbox from '@/shared/Checkbox';
import { api } from '@/api/api.v2';

import { groupsList, treeLevels } from './categories';
import { Checkmark } from './icons';

function reverseMapObject(obj) {
    const reversedObj = {};
    Object.entries(obj).forEach(([key, value]) => {
        reversedObj[value] = key;
    });
    return reversedObj;
}

export const mapNodeType = {
    is_show_develops: 'develop', // 'С объектами / элементами разработки'
    is_show_areas: 'area', // 'С площадями'
    is_show_elevations: 'elevation', // 'С куполами, поднятиями'
    is_show_structure_well: 'groupStructureWell', // 'Со структурно-параметрическими'
    is_show_not_deep_well: 'itemNotDeepWell', // 'С неглубокими скважинами',
    is_show_license_zones: 'license', // 'С лицензионными участками'
};

export const CategoryList = ({
    fetchTreeData,
    treeLevelsKeys,
    setTreeLevelsKeys,
    groupFilterValue,
    setGroupFilterValue,
}) => {
    const treeLevels_onChange = async values => {
        const data = {};
        const reversedObj = reverseMapObject(mapNodeType);
        for (const item of Object.keys(reversedObj)) {
            if (values.includes(item)) {
                data[reversedObj[item]] = true;
            } else {
                data[reversedObj[item]] = false;
            }
        }

        try {
            const response = await api.user.saveData({
                key: 'userSettings',
                update: true,
                data: data,
            });

            if (!response) {
                throw new Error('Не удалось применить пользовательские настройки (userSettings): ', response);
            }

            setTreeLevelsKeys(values);
            fetchTreeData(); // Требуется освежить данные дерева, так как реорганизация структуры происходит на сервере.
        } catch (error) {
            console.error('Ошибка на сервере: ', error);
        }
    };

    const handleGroupChange = event => {
        event.stopPropagation();
        setGroupFilterValue(event.target.value);
    };

    return (
        <section
            id="dropdownList"
            className="mt-3 flex flex-col rounded border border-solid border-gray-500 bg-white shadow dark:border-fill-primary dark:bg-block-secondary"
        >
            <AntdRadio.Group className="p-2" onChange={handleGroupChange} value={groupFilterValue}>
                {groupsList.map(({ id, title, code }) => {
                    return (
                        <div key={id} className="flex items-center rounded-sm p-2">
                            <div className="flex h-4 w-4 items-center justify-center">
                                {code === groupFilterValue ? (
                                    <Checkmark className="stroke-current text-black dark:text-font-primary" />
                                ) : null}
                            </div>
                            <AntdRadio
                                className="m-0 w-full text-xs text-black dark:text-font-quarternary"
                                value={code}
                            >
                                {title}
                            </AntdRadio>
                        </div>
                    );
                })}
            </AntdRadio.Group>

            {!isEmpty(treeLevels[groupFilterValue]) && (
                <div className="flex flex-col border-t border-gray-500 p-2 dark:border-fill-primary">
                    <Checkbox.Group
                        options={treeLevels[groupFilterValue]}
                        value={treeLevelsKeys}
                        onChange={treeLevels_onChange}
                        className="flex w-full flex-col"
                    />
                </div>
            )}
        </section>
    );
};
